module.exports = __webpack_public_path__ + "img/membership.de260a16.png";